export const PRECACHE_DATA = 'images/PRECACHE_DATA';



// WEBPACK FOOTER //
// ./src/redux/Precache/constants.js